<ul class="breadcrumb">
    <li><a [routerLink]="['/home']"><span class="color-soft-grey-axial">{{'general.breadcrumb.you_are' | translate}} </span>{{'general.breadcrumb.home' | translate}}</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/entities']">{{ 'general.configuration' | translate}}</a></li>
    <li><i class="pi pi-angle-right"></i></li>
    <li><a [routerLink]="['/configuration/provinces']">{{ 'province.entity.name_plural' | translate}}</a></li>
    <!--<li *ngIf="view"><a [routerLink]="['/configuration/provinces']">{{view.getEntityBaseName(true)}}</a></li>-->
</ul>
<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000"></p-confirmDialog>

<!--<app-view #view [code]="'provinces.list'" [model]="provincesFilters" (onEvent)="onEvent($event)"></app-view>-->

<p-card>
    <ng-template pTemplate="header">
      <div class="p-card-title">
        {{ 'general.filter.title' | translate}}
        <div class="p-card-title-actions">
          <a (click)="search()"><i class="fas fa-search"></i>&nbsp;{{ 'general.action.search' | translate}} </a>
        </div>
      </div>
    </ng-template>
    <div class="p-grid">
        <div class="p-col p-field">
          <label for="name">{{ 'province.entity_fields.name' | translate}}</label>
            <input id="name" type="text" pInputText [(ngModel)]="provincesFilters.name" />
        </div>
        <div class="p-col-4 p-field">
          <label for="country_id">{{ 'province.entity_fields.country_id' | translate}}</label>
            <p-dropdown [options]="countries" optionLabel="name" optionValue="id" [(ngModel)]="provincesFilters.country_id"  placeholder="{{ 'general.select' | translate}}"></p-dropdown>
        </div>
    </div>
    <!--div class="p-grid">
          <div class="p-col p-ai-right">
              <p-button label="Limpiar filtros" (click)="clearFilters()" styleClass="p-button-secondary"></p-button>
              <p-button label="Buscar" (click)="search()" class="p-ml-2"></p-button>
          </div>
      </div-->
</p-card>
<br>
<p-card styleClass="p-card-content-fit">
    <ng-template pTemplate="header">
      <div class="p-card-title">
        {{ 'province.entity.name_plural' | translate}}
        <div class="p-card-title-actions">
          <a (click)="edit({ id: 0 })">
            <fa-icon [icon]="['fas', 'plus-circle']"></fa-icon> {{ 'general.action.new' | translate}}
          </a>
        </div>
      </div>
    </ng-template>
    <p-table #grid [value]="provinces" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
        [paginator]="true" [rows]="10" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
        currentPageReportTemplate="{{ 'general.resumen_table_records' | translate: { first: first, last: last, totalRecords: totalRecords } }}"
        [rowsPerPageOptions]="[5,10,25,50]"  paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="id" width="100">{{ 'province.entity_fields.id' | translate}}</th>
                <th pSortableColumn="name">{{ 'province.entity_fields.name' | translate}}</th>
                <th pSortableColumn="country.name">{{ 'province.entity_fields.country_id' | translate}}</th>
                <th width="100"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-province>
            <tr (dblclick)="edit(province)">
                <td>{{province.id}}</td>
                <td>{{province.name}}</td>
                <td>{{province.country.name}}</td>
                <td class="grid-actions">
                    <a (click)="edit(province)">
                        <fa-icon [icon]="['far', 'edit']"></fa-icon>
                    </a>
                    <a (click)="delete(province)" class="color-danger">
                        <fa-icon [icon]="['far', 'trash-alt']"></fa-icon>
                    </a>
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-card>
